import axios from 'axios'

export default function multiRequest(configs = []) {
  const requests = configs.map(({ url, data }) => axios({ url, data }))

  return new Promise((resolve, reject) => {
    Promise.all(requests)
      .then((res) => {
        const obj = {}
        configs.forEach((config, index) => {
          const { key } = config
          obj[key] = res[index].data
        })

        resolve(obj)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
